import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import styles from './Notification.module.scss';

const Notification = ({ children, variant, header, ...props }) => {
    const intl = useIntl();
    return (
        <div
            className={['govuk-notification-banner', styles[variant]].join(' ')}
            role="region"
            aria-label={intl.formatMessage({ id: 'Notification.notification' })}
            {...props}
        >
            {header &&
                <div className="govuk-notification-banner__header">
                    <h2 className="govuk-notification-banner__title">{header}</h2>
                </div>
            }
            <div className='govuk-notification-banner__content'>
                <div className={['govuk-notification-banner__heading', styles['notification-banner']].join(' ')}>
                    {children}
                </div>
            </div>
        </div>
    );
};

Notification.proptypes = {
    variant: PropTypes.oneOf(['primary', 'secondary', 'error', 'warning', 'success', 'info']),
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

Notification.defaultProps = {
    variant: 'primary'
};

export default Notification;
